<template>
  <form class="w-100" @submit.prevent="submit">
    <div class="row">
      <div class="col-12 text-left">
        <button v-if="id !== 'new'" @click="del" type="button" class="btn btn-danger">
          حذف دسته بندی
          <i class="fas fa-trash"/>
        </button>
        <button type="submit" class="btn btn-success mr-2">
          <span v-if="id !== 'new'">
            بروررسانی دسته بندی
          <i class="far fa-save"/>
          </span>
          <span v-else>
            ذخیره دسته بندی جدید
                <i class="fas fa-plus"/>
          </span>
        </button>

        <hr>
      </div>
      <div class="col-12">

        <div class="row">
          <div v-if="id !== 'new'" class="col-12 col-sm-6 col-lg-3">
            <StatsCard>
              <div class="icon-big text-center icon-info" slot="header">
                <i class="far fa-kiss-beam"/>
              </div>
              <div class="numbers" slot="content">
                <p>تعداد داستان ها</p>
                {{item.stories_count || 0}}
              </div>
            </StatsCard>
          </div>
          <div class="col-12">
            <card class="card" title="اطلاعات پایه">
              <div>
                <div class="form-row">
                  <div class="col-12 col-lg-4 mb-3">
                    <div class="form-group text-right">
                      <label for="name">عنوان</label>
                      <input id="name" type="text" class="form-control" placeholder="عنوان"
                             v-model="item.title">
                    </div>
                  </div>
                  <div class="col-12 col-lg-4 mb-3">
                    <div class="form-group text-right">
                      <label for="order">ترتیب</label>
                      <input id="order" type="number" class="form-control" placeholder="ترتیب"
                             v-model.number="item.order">
                    </div>
                  </div>
                  <div class="col-12 col-lg-4 mb-3">
                    <div class="form-group text-right">
                      <label for="isSpecial">ویژه</label>
                      <fv-switch id="isSpeCial" class="form-control d-block" placeholder="ویژه"
                                 v-model="item.is_special"/>
                    </div>
                  </div>
                  <div class="col-12 col-lg-4 mb-3">
                    <div class="form-group text-right">
                      <label for="enable">فعال</label>
                      <fv-switch id="enable" class="form-control d-block" placeholder="فعال"
                                 v-model="item.enabled"/>
                    </div>
                  </div>
                </div>


                <div class="clearfix" />

              </div>
            </card>
          </div>
          <div class="col-12">

            <card class="card" title="توضیحات">
              <div>
                <div class="form-row">
                  <div class="col-12 mb-3">
                    <div class="form-group text-right">
                      <label for="description">توضیحات(حداکثر 20 کلمه)</label>
                      <appTextEditor id="description" placeholder="توضیحات"
                                     v-model="item.description"/>
                    </div>
                  </div>
                </div>
              </div>
            </card>
          </div>
          <div class="col-12">
            <card class="card" title="مدیا">
              <div>
                <div class="form-row">
                  <div class="col-12 mb-3">
                    <div class="form-group text-right">
                      <label for="banner">بنر</label>
                      <appFileUploader id="banner" v-model="item.banner"/>
                    </div>
                  </div>
                  <div class="col-12 mb-3">
                    <div class="form-group text-right">
                      <label for="color">رنگ پیش زمینه</label>
                      <appColorPicker id="color" v-model="item.background_color"/>
                    </div>
                  </div>
                </div>
              </div>
            </card>
          </div>
        </div>

      </div>
    </div>
  </form>
</template>
<script>
  import Modela from 'modela'
  import categoryModel from "../../models/category"
  import UserCard from "../UserProfile/UserCard.vue";
  import MembersCard from "../UserProfile/MembersCard.vue";
  import {mapActions} from "vuex"
  import appTextEditor from "../../components/appTextEditor";
  import appFileUploader from "../../components/appFileUploader";
  import {StatsCard} from "@/components/index";
  import appColorPicker from "../../components/appColorPicker";
  import versionModel from "../../models/versions";

  export default {
    name: 'category_edit',
    components: {
      UserCard,
      MembersCard,
      appTextEditor,
      appFileUploader,
      StatsCard,
      appColorPicker
    },
    data() {
      const {params} = this.$route
      const {id} = params
      return {
        ...mapActions('main', [
          'crud'
        ]),
        id,
        item: {},
      }
    },
    methods: {
      async getData() {
        try {
          this.$store.commit('main/SET', {key: 'loading', value: true})
          const category = await this.crud({
            action: 'get',
            section: 'categories',
            id: this.id,
            showError: true
          })
          if (category.data) {
            const result = category.data
            let item = new Modela(categoryModel)
            item = item.$clean()
            item = item.$set(result)
            this.item = item.$clean().$export()
          }
        } catch (e) {
          console.log(e)
        } finally {
          this.$store.commit('main/SET', {key: 'loading', value: false})
        }
      },
      async post() {
        try {
          this.$store.commit('main/SET', {key: 'loading', value: true})
          const newCat = await this.crud({
            action: 'post',
            section: 'categories',
            data: this.item,
            showError: true
          })
          await this.$successAlert()
          this.$router.go(-1)
          // await this.$router.push({name: 'categories'})
        } catch (e) {
          // console.log(e)
        } finally {
          this.$store.commit('main/SET', {key: 'loading', value: false})
        }

      },
      async put() {
        try {
          this.$store.commit('main/SET', {key: 'loading', value: true})
          const updateCat = await this.crud({
            action: 'put',
            section: 'categories',
            id: this.id,
            data: this.item,
            showError: true
          })
          this.$successAlert()
          this.$router.go(-1)
          // await this.$router.push({name: 'categories'})
        } catch (e) {
          // console.log(e)
        } finally {
          this.$store.commit('main/SET', {key: 'loading', value: false})
        }

      },
      async del() {
        if (!await this.$confirmAlert())
          return false
        try {
          this.$store.commit('main/SET', {key: 'loading', value: true})
          const deleted = await this.crud({
            action: 'delete',
            section: 'categories',
            id: this.id,
            showError: true
          })
          await this.$successAlert()
          // await this.$router.push({name: 'categories'})
          this.$router.go(-1)
        } catch (e) {
          // console.log(e)
        } finally {
          this.$store.commit('main/SET', {key: 'loading', value: false})
        }
      },
      async submit() {
        if (this.id !== 'new')
          this.put()
        else
          this.post()
      }
    },
    async created() {
      if (this.id !== 'new')
        await this.getData()
      else {
        let item = new Modela(categoryModel)
        this.item = item.$clean().$export()
      }
    }
  };
</script>
<style>
</style>
